import React, { useState } from "react";
import { FieldArray, useFormikContext } from "formik";
import _ from "lodash";
import { FormTextField } from "../../../../../partials/content/Forms/FormField";
import { Table } from "react-bootstrap";
import { Card } from "react-bootstrap";
import NumberFormat from "react-number-format";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import SearchOutletStocks from "../../outlets/outletDetail/searchOutletStocks";
import { DialogActions, Typography } from "@material-ui/core";
import SearchTax from "../../../setup/finance/searchTax";
import { AttachMoney, Percent } from "@mui/icons-material";
import { amountByPercent, percentByAmount } from "../../../../../utils/utils";
import PosItemDetail from "./posItemDetail";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { checkDiscount } from "../../../../../services/sales/discountService";
import SalesItemDiscount from "../../sales-item/SalesItemDiscount";
import { DateTime } from "luxon";
import Illustration from "../../../../../partials/content/Illustration";
import Swal from "sweetalert2";
function PosItem(props) {
  const { values, setFieldValue } = useFormikContext();
  const [buttonGroupActive, setButtonGroupActive] = useState(0);
  const [openSearchStock, setOpenSearchStock] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [itemIndex, setItemIndex] = useState(0);
  const [openSearchTax, setOpenSearchTax] = useState(false);
  const [openItemDetail, setOpenItemDetail] = useState(false);
  const [discounts, setDiscounts] = useState([]);
  const [openDiscount, setOpenDiscount] = useState(false);
  return (
    <React.Fragment>
      <FieldArray name="salesPosItem">
        {({ push, remove }) => (
          <React.Fragment>
            <div className="row mt-3 mb-3">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <button
                  type="button"
                  className="btn btn-label-info btn-md btn-pill btn-bold"
                  onClick={() => {
                    checkDiscountData();
                  }}
                >
                  <i className="fas fa-percentage"></i>
                  Available Discounts
                </button>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <div className="card">
                  <Table striped borderless size="sm" responsive="xl">
                    <thead>
                      <tr>
                        <th style={{ width: "70%" }}>
                          <Typography className="mx-1 kt-font-bolder">
                            Item Name
                          </Typography>
                        </th>
                        <th style={{ width: "25%" }}>
                          <Typography className="mx-1 kt-font-bolder text-right">
                            Total Price
                          </Typography>
                        </th>
                        <th>
                          <Typography className="mx-1 kt-font-bolder">
                            Actions
                          </Typography>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {values.salesPosItem && values.salesPosItem.length > 0 ? (
                        values.salesPosItem.map((item, index) => (
                          <tr key={index}>
                            <td>
                              <Typography className="mx-1 my-1">
                                {item.itemName}
                              </Typography>
                              <Typography className="mx-1 my-1 text-muted">
                                {`${item.qty} ${item.uomName} - ${
                                  item.receiveType === 1
                                    ? "Take Away"
                                    : item.receiveType === 2
                                    ? "Delivery"
                                    : item.receiveType === 3
                                    ? "Request Item"
                                    : ""
                                }`}
                              </Typography>
                              {item.discountPercent > 0 ? (
                                <Typography className="mx-1 my-1 text-muted">
                                  {`Disc (${item.discountPercent}%) ${values.currencyCode} ${item.discountAmount}`}
                                </Typography>
                              ) : null}
                              {item.taxPercent > 0 ? (
                                <Typography className="mx-1 my-1 text-muted">
                                  {`Tax (${item.taxPercent}%) ${values.currencyCode} ${item.taxAmount}`}
                                </Typography>
                              ) : null}
                            </td>
                            <td>
                              <Typography component="div" className="mx-1 my-1">
                                <NumberFormat
                                  value={item.totalPrice}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                            <td
                              style={{ whiteSpace: "nowrap" }}
                              className="text-center"
                            >
                              <BootstrapTooltip title="Edit Item">
                                <button
                                  type="button"
                                  className="btn btn-icon btn-label-primary btn-md btn-circle mx-1"
                                  onClick={() => {
                                    setItemIndex(index);
                                    setOpenItemDetail(true);
                                  }}
                                >
                                  <i className="fas fa-edit"></i>
                                </button>
                              </BootstrapTooltip>
                              {item.discountFreeItemID === 0 ? (
                                <BootstrapTooltip title="Delete Item">
                                  <button
                                    type="button"
                                    className="btn btn-icon btn-label-danger btn-md btn-circle mx-1"
                                    onClick={() => {
                                      let salesPosItem = [
                                        ...values.salesPosItem,
                                      ];
                                      salesPosItem = _.remove(
                                        salesPosItem,
                                        (n, indexData) => {
                                          return index !== indexData;
                                        }
                                      );
                                      let discountPercent = 0;
                                      let discountAmount = 0;
                                      const taxPercent = parseFloat(
                                        values.taxPercent
                                      );
                                      const subTotal = _.sumBy(
                                        salesPosItem,
                                        "totalPrice"
                                      );
                                      let total = subTotal;
                                      if (
                                        values.discountID > 0 &&
                                        values.discount.discountType === 1
                                      ) {
                                        if (
                                          values.discount.discountAmountType ===
                                          2
                                        ) {
                                          discountAmount =
                                            values.discount.discountValue;
                                          discountPercent = percentByAmount(
                                            discountAmount,
                                            total
                                          );
                                        } else {
                                          discountPercent =
                                            values.discount.discountPercent;
                                          discountAmount = amountByPercent(
                                            discountPercent,
                                            total
                                          );
                                        }
                                      } else {
                                        discountPercent = parseFloat(
                                          values.discountPercent
                                        );
                                        discountAmount = amountByPercent(
                                          discountPercent,
                                          subTotal
                                        );
                                      }

                                      total -= discountAmount;
                                      let taxAmount = amountByPercent(
                                        taxPercent,
                                        total
                                      );

                                      total += taxAmount;

                                      setFieldValue("subTotal", subTotal);
                                      setFieldValue(
                                        "discountPercent",
                                        discountPercent
                                      );
                                      setFieldValue(
                                        "discountAmount",
                                        discountAmount
                                      );
                                      setFieldValue("taxAmount", taxAmount);
                                      setFieldValue("total", total);

                                      remove(index);
                                    }}
                                  >
                                    <i className="fas fa-trash-alt"></i>
                                  </button>
                                </BootstrapTooltip>
                              ) : null}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td className="text-center" colSpan="3">
                            <Illustration
                              guidance="No selected product yet"
                              guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                            ></Illustration>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Card>
                  <Card.Body className="pb-0">
                    <Table borderless size="sm" responsive="xl">
                      <tbody>
                        {values.discountID > 0 ? (
                          <tr className="border-bottom">
                            <td style={{ width: "30%" }}>
                              <Typography className="mb-3 kt-font-bolder">
                                Discount Applied
                              </Typography>
                            </td>
                            <td style={{ width: "60%" }} colSpan="2">
                              <Typography className="mb-3 kt-font-bolder">
                                {values.discountName}
                              </Typography>
                            </td>
                            <td style={{ width: "10%" }}>
                              <BootstrapTooltip title="Delete Discount">
                                <button
                                  type="button"
                                  className={`btn btn-icon btn-label-danger btn-md float-right btn-circle mx-1`}
                                  onClick={() => {
                                    deleteDiscount();
                                  }}
                                >
                                  <i className="fas fa-trash-alt"></i>
                                </button>
                              </BootstrapTooltip>
                            </td>
                          </tr>
                        ) : null}
                        <tr className="border-bottom">
                          <td style={{ width: "25%" }}>
                            <Typography className="mb-3 kt-font-bolder">
                              Sub Total
                            </Typography>
                          </td>
                          <td style={{ width: "5%" }}></td>
                          <td style={{ width: "30%" }}></td>
                          <td style={{ width: "40%" }}>
                            <Typography
                              component="div"
                              className="mb-3 kt-font-bolder"
                            >
                              <NumberFormat
                                value={values.subTotal}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale={2}
                                renderText={(value) => (
                                  <div className="float-right">
                                    {values.currencyCode} {value}
                                  </div>
                                )}
                              />
                            </Typography>
                          </td>
                        </tr>
                        <tr className="border-bottom">
                          <td>
                            <Typography className="my-3">Discount</Typography>
                          </td>
                          <td>
                            <div
                              className="btn-group btn-group-sm my-2 float-right"
                              role="group"
                            >
                              <BootstrapTooltip title="Input By Amount">
                                <button
                                  type="button"
                                  className={`btn btn-${
                                    buttonGroupActive === 0
                                      ? "success"
                                      : "label-dark"
                                  } btn-sm btn-bold`}
                                  onClick={() => {
                                    setButtonGroupActive(0);
                                  }}
                                >
                                  <AttachMoney />
                                </button>
                              </BootstrapTooltip>
                              <BootstrapTooltip title="Input By Percentage">
                                <button
                                  type="button"
                                  className={`btn btn-${
                                    buttonGroupActive === 1
                                      ? "success"
                                      : "label-dark"
                                  } btn-sm btn-bold`}
                                  onClick={() => {
                                    setButtonGroupActive(1);
                                  }}
                                >
                                  <Percent />
                                </button>
                              </BootstrapTooltip>
                            </div>
                          </td>
                          <td>
                            {buttonGroupActive === 0 ? (
                              <FormTextField
                                label="Discount Amount"
                                name="discountAmount"
                                currencyField
                                currencyCode={values.currencyCode}
                                onChangeValue={(value) => {
                                  handleCalculateDiscount(value, "amount");
                                }}
                                readonly={
                                  values.discountID > 0 &&
                                  values.discount.discountType === 1
                                    ? true
                                    : false
                                }
                              />
                            ) : buttonGroupActive === 1 ? (
                              <FormTextField
                                label="Discount Percent"
                                name="discountPercent"
                                percentageField
                                onBlur={(value) => {
                                  handleCalculateDiscount(value, "percent");
                                }}
                                readonly={
                                  values.discountID > 0 &&
                                  values.discount.discountType === 1
                                    ? true
                                    : false
                                }
                              />
                            ) : null}
                          </td>
                          <td>
                            <Typography component="div" className="my-3">
                              <NumberFormat
                                value={values.discountAmount}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale={2}
                                renderText={(value) => (
                                  <div className="float-right">
                                    - {values.currencyCode} {value}
                                  </div>
                                )}
                              />
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Typography className="my-3">Tax</Typography>
                          </td>
                          <td></td>
                          <td>
                            <FormTextField
                              label="Tax Percent"
                              name="taxPercent"
                              percentageField
                              searchButton
                              readonly
                              onSearchClick={() => {
                                setOpenSearchTax(true);
                              }}
                            />
                          </td>
                          <td>
                            <Typography component="div" className="my-3">
                              <NumberFormat
                                value={values.taxAmount}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale={2}
                                renderText={(value) => (
                                  <div className="float-right">
                                    {values.currencyCode} {value}
                                  </div>
                                )}
                              />
                            </Typography>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Card.Body>
                  <Card.Footer>
                    <Table borderless size="sm" responsive="xl">
                      <tbody>
                        <tr>
                          <td style={{ width: "50%" }}>
                            <Typography variant="h6" className="kt-font-bolder">
                              Grand Total
                            </Typography>
                          </td>
                          <td style={{ width: "0%" }}></td>
                          <td style={{ width: "0%" }}></td>
                          <td style={{ width: "50%" }}>
                            <Typography
                              variant="h6"
                              component="div"
                              className="kt-font-bolder"
                            >
                              <NumberFormat
                                value={values.total}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale={2}
                                renderText={(value) => (
                                  <div className="float-right">
                                    {values.currencyCode} {value}
                                  </div>
                                )}
                              />
                            </Typography>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Card.Footer>
                </Card>
              </div>
            </div>
          </React.Fragment>
        )}
      </FieldArray>
      <DialogLayout
        open={openSearchTax}
        title="Search Tax"
        onCloseDialog={() => {
          setOpenSearchTax(false);
        }}
        maxWIdth="sm"
      >
        <SearchTax
          onSelectTax={(tax) => {
            handleCalculateTax(tax.taxPercent, "percent");
            setOpenSearchTax(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchTax(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchStock}
        title="Search Stock"
        onCloseDialog={() => {
          setOpenSearchStock(false);
        }}
        //fullScreen={true}
        maxWIdth="lg"
      >
        <SearchOutletStocks
          outletID={values.outletID}
          itemID={selectedItem.itemID}
          varCode={selectedItem.varCode}
          onSelectStock={(stock) => {
            setFieldValue(`salesPosItem[${itemIndex}].batchID`, stock.batchID);
            setOpenSearchStock(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchStock(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openItemDetail}
        title="Item Detail"
        onCloseDialog={() => {
          setOpenItemDetail(false);
        }}
        maxWIdth="sm"
      >
        <PosItemDetail
          itemIndex={itemIndex}
          onSaveChanges={(itemSelected) => {
            setFieldValue(`salesPosItem[${itemIndex}]`, itemSelected);
            const salesPosItem = [...values.salesPosItem];
            salesPosItem[itemIndex] = itemSelected;
            const taxPercent = parseFloat(values.taxPercent);
            const subTotal = _.sumBy(salesPosItem, "totalPrice");
            let total = subTotal;
            let discountPercent = 0;
            let discountAmount = 0;

            if (values.discountID > 0 && values.discount.discountType === 1) {
              if (values.discount.discountAmountType === 2) {
                discountAmount = values.discount.discountValue;
                discountPercent = percentByAmount(discountAmount, total);
              } else {
                discountPercent = values.discount.discountPercent;
                discountAmount = amountByPercent(discountPercent, total);
              }
            } else {
              discountPercent = parseFloat(values.discountPercent);
              discountAmount = amountByPercent(discountPercent, subTotal);
            }

            total -= discountAmount;
            let taxAmount = amountByPercent(taxPercent, total);

            total += taxAmount;

            setFieldValue("subTotal", subTotal);
            setFieldValue("discountPercent", discountPercent);
            setFieldValue("discountAmount", discountAmount);
            setFieldValue("taxAmount", taxAmount);
            setFieldValue("total", total);

            setOpenItemDetail(false);
          }}
          onCloseItemDetail={() => {
            setOpenItemDetail(false);
          }}
        />
      </DialogLayout>
      <SalesItemDiscount
        discounts={discounts}
        property="salesPosItem"
        openDiscount={openDiscount}
        setOpenDiscount={setOpenDiscount}
        onSelectDiscount={(selectedDiscount) => {
          setFieldValue("discount", selectedDiscount);
          if (selectedDiscount.discountType === 1) {
            if (selectedDiscount.discountAmountType === 2) {
              handleCalculateDiscount(selectedDiscount.discountValue, "amount");
            } else {
              handleCalculateDiscount(
                selectedDiscount.discountPercent,
                "percent"
              );
            }
          }
        }}
      />
    </React.Fragment>
  );

  function handleCalculateDiscount(value, type = "") {
    if (value) {
      let discountPercent = 0;
      let discountAmount = 0;
      const taxAmount = parseFloat(values.taxAmount);
      const subTotal = _.sumBy(values.salesPosItem, "totalPrice");
      if (type === "percent") {
        discountPercent = parseFloat(value);
        discountAmount = amountByPercent(discountPercent, subTotal);
      } else if (type === "amount") {
        discountAmount = parseFloat(value);
        discountPercent = percentByAmount(discountAmount, subTotal);
      }
      setFieldValue("discountPercent", discountPercent);
      setFieldValue("discountAmount", discountAmount);
      setFieldValue("subTotal", subTotal);
      setFieldValue("total", subTotal - discountAmount + taxAmount);
    }
  }

  function handleCalculateTax(value, type) {
    if (value) {
      let taxPercent = 0;
      let taxAmount = 0;
      const discountAmount = parseFloat(values.discountAmount);
      const subTotal = _.sumBy(values.salesPosItem, "totalPrice");
      if (type === "percent") {
        taxPercent = parseFloat(value);
        taxAmount = amountByPercent(taxPercent, subTotal);
      } else if (type === "amount") {
        taxAmount = parseFloat(value);
        taxPercent = percentByAmount(taxAmount, subTotal);
      }
      setFieldValue("taxPercent", taxPercent);
      setFieldValue("taxAmount", taxAmount);
      setFieldValue("total", subTotal - discountAmount + taxAmount);
    }
  }

  function deleteDiscount() {
    setFieldValue("discountID", 0);
    setFieldValue("discountName", "");
    setFieldValue("discount", {
      discountID: 0,
      discountName: "",
      discountType: 1,
      discountAmountType: 1,
      discountPercnet: 0,
      discountValue: 0,
    });
    const salesPosItem = [];
    for (const item of values.salesPosItem) {
      if (item.discountFreeItemID === 0) {
        salesPosItem.push(item);
      }
    }
    if (values.discountType === 1) {
      setFieldValue("discountPercent", 0);
      setFieldValue("discountAmount", 0);
    }
    setFieldValue("salesPosItem", salesPosItem);
  }

  async function checkDiscountData() {
    let documentType = "";
    let documentDate = DateTime.now().startOf("day");
    let salesItem = [];
    documentType = "POS";
    documentDate = DateTime.now().startOf("day");

    for (const item of values.salesPosItem) {
      salesItem.push({
        itemID: item.itemID,
        varCode: item.varCode,
        qty: item.qty,
        uomID: item.uomID,
      });
    }
    const response = await checkDiscount({
      documentType,
      documentDate,
      currencyID: values.currencyID,
      exchangeRate: values.exchangeRate,
      grandTotal: values.total,
      salesItem,
    });
    const { data } = response.data;
    if (data.discounts.length > 0) {
      setDiscounts(data.discounts);
      setOpenDiscount(true);
    } else {
      Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        },
        buttonsStyling: false,
      }).fire({
        title: "Not Available",
        text: "There are no available discounts yet",
        icon: "info",
        showCloseButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
      });
    }
  }
}

export default PosItem;
